import React from 'react';
import styles from './styles.module.css';
import StageProgress from '../stage-progress';
import FormButtons from '../form-buttons';

export default ({ title, subTitle, stages, children, footerProps }) => (
  <div id="form-overlay" className={styles.container}>
    <div className={styles.header}>
      <div className={styles.inner}>
        <h2>{title}</h2>
        <p>{subTitle}</p>
      </div>
    </div>

    <div className={styles.middle}>
      <div className={styles.inner}>
        <div className={styles.split}>
          {stages && (
            <div className={styles.steps}>
              <StageProgress stages={stages} />
            </div>
          )}
          <div className={styles.form}>{children}</div>
        </div>
      </div>
    </div>

    {footerProps && (
      <div className={styles.footer}>
        <div className={styles.inner}>
          <FormButtons {...footerProps} />
        </div>
      </div>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/overlay-wrapper/index.js